import { defineStore } from 'pinia';

export const useBookingStore = defineStore('bookingStore', {
  state: () => ({
    order: null,
    errors: [],
    item: null,
    aeroflot: null,
  }),
  getters: {
    order: (state) => state.order,
    aeroflotResult: (state) => state.aeroflot,
  },
  actions: {
    async get(payload) {
      let params = new URLSearchParams(payload).toString();
      const { data: item } = await useFetch(`/api/v2/booking?${params}`);
      if (item.value) this.item = item.value;
    },
    async checkOrder(payload) {
      const { data: item } = await useFetch(`/api/v2/aeroflot/get_order_info`, {
        method: 'post',
        body: {
          "aeroflotOrderId": payload.id,
          "transactionDate": payload.transactionDate
        }
      });
      if (item && item.value) this.aeroflot = item.value;
    },
    async create(payload) {
      this.errors = [];
      try {
        const { error, data: order } = await useFetch('/api/v2/order/store', {
          method: 'post',
          body: payload 
        });
        if (error && error.value && error.value.data) {
          Object.values(error.value.data.errors).forEach(e => {
            useNuxtApp().$toast.error(e[0])
          })
          this.errors = Object.keys(error.value.data.errors);
        }
        if (order && order.value && order.value.payment_url) {
          if (window && window.ym) {
              window.ym(99787939, 'reachGoal', 'form-success');
          }
          window.location.href = order.value.payment_url;
        }
        //if (order) this.order = order.value;
      } catch (error) {
        console.log(error);
      }
    },
    async oneClickCreate(payload) {
      this.errors = [];
      try {
        const { error, data: order } = await useFetch('/api/v2/order/one_click_store', {
          method: 'post',
          body: payload
        });
        if (order && order.value && order.value.message && order.value.message === 'success') {
            if (window && window.ym) {
                window.ym(99787939, 'reachGoal', 'order_1click');
            }
            return true;
        }

        return false;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    clearError(error)  {
      if (this.errors.includes(error)) {
        let index = this.errors.indexOf(error);
        if (index > -1) {
          this.errors.splice(index, 1)
        }
      }
    }
  }
});